import { render, staticRenderFns } from "./ArticleBox.vue?vue&type=template&id=d97ac046&scoped=true"
import script from "./ArticleBox.vue?vue&type=script&lang=js"
export * from "./ArticleBox.vue?vue&type=script&lang=js"
import style0 from "./ArticleBox.vue?vue&type=style&index=0&id=d97ac046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97ac046",
  null
  
)

export default component.exports